import { DIALOGS } from '@witmetrics/unison-core';
import { useActiveLab, useActivePractice } from '@witmetrics/data-store';
import type { NavigationKey, ShortcutKey } from '@/types';
import { useAppState } from '@/providers/AppStateProvider';
import AccountsDialog from '@/dialogs/AccountsDialog';
import CreditsDialog from '@/dialogs/CreditsDialog';
import LoginDialog from '@/dialogs/LoginDialog';
import ProjectSearchDialog from '@/dialogs/ProjectSearchDialog';
import OrderSearchDialog from '@/dialogs/OrderSearchDialog';
import ShortcutsDialog from '@/dialogs/ShortcutsDialog';
import NavigationDialog from '@/dialogs/NavigationDialog';
import UnisonProjectTaskDialog from '@/dialogs/UnisonProjectTaskDialog';
import OrderTaskDialog from '@/dialogs/OrderTaskDialog';
import PracticeOrderDialog from '@/dialogs/PracticeOrderDialog';
import NewPatientDialog from '@/dialogs/NewPatientDialog';
import StartCaseDialog from '@/dialogs/StartCaseDialog';

const {
  ACCOUNTS,
  CASE,
  CREDITS,
  LOGIN,
  NAVIGATION,
  ORDER,
  PATIENT,
  SEARCH,
  SHORTCUTS,
  TASK,
} = DIALOGS;

export type DialogsManagerProps = {
  onSelectShortcut: (shortcut: ShortcutKey) => void;
  onSelectNavigation: (shortcut: NavigationKey) => void;
};

export default function DialogsManager({
  onSelectShortcut,
  onSelectNavigation,
}: DialogsManagerProps) {
  const {
    activeDialogs,
    activeProjectId,
    activeOrderId,
    onSelectLead,
    onCloseDialog,
  } = useAppState();
  const activePractice = useActivePractice();
  const activeLab = useActiveLab();

  return (
    <>
      {activeDialogs[CASE] && activePractice && (
        <StartCaseDialog onClose={() => onCloseDialog(CASE)} />
      )}
      {activeDialogs[PATIENT] && activePractice && (
        <NewPatientDialog
          onSelect={({ id }) => onSelectLead(id)}
          onClose={() => onCloseDialog(PATIENT)}
        />
      )}
      {activeDialogs[TASK] && activePractice && (
        <UnisonProjectTaskDialog
          projectId={activeProjectId}
          onClose={() => onCloseDialog(TASK)}
        />
      )}
      {activeDialogs[TASK] && activeLab && (
        <OrderTaskDialog
          orderId={activeOrderId}
          onClose={() => onCloseDialog(TASK)}
        />
      )}
      {activeDialogs[ORDER] && activePractice && (
        <PracticeOrderDialog
          projectId={activeProjectId}
          onClose={() => onCloseDialog(ORDER)}
        />
      )}
      {activeDialogs[SEARCH] && activePractice && (
        <ProjectSearchDialog onClose={() => onCloseDialog(SEARCH)} />
      )}
      {activeDialogs[SEARCH] && activeLab && (
        <OrderSearchDialog onClose={() => onCloseDialog(SEARCH)} />
      )}
      {activeDialogs[SHORTCUTS] && (
        <ShortcutsDialog
          onSelect={onSelectShortcut}
          onClose={() => onCloseDialog(SHORTCUTS)}
        />
      )}
      {activeDialogs[NAVIGATION] && (
        <NavigationDialog
          onSelect={onSelectNavigation}
          onClose={() => onCloseDialog(NAVIGATION)}
        />
      )}
      {activeDialogs[ACCOUNTS] && (
        <AccountsDialog onClose={() => onCloseDialog(ACCOUNTS)} />
      )}
      {activeDialogs[CREDITS] && (
        <CreditsDialog onClose={() => onCloseDialog(CREDITS)} />
      )}
      {activeDialogs[LOGIN] && (
        <LoginDialog onClose={() => onCloseDialog(LOGIN)} />
      )}
    </>
  );
}
